export default __webpack_public_path__ + "static/uchi2020-a362385d74f8d210bc46525180273b7e.jpg";